import type { RouteLocationAsRelative } from 'vue-router'

import { EmployeeID } from './models/employee'

export interface EmployeeRef {
  id: EmployeeID
  orgSlug: string
}

export const employeeRoutes = {
  list: (
    org: string,
  ): RouteLocationAsRelative<'/(app)/[org]/people/employees/'> => ({
    name: '/(app)/[org]/people/employees/',
    params: { org },
  }),

  detail: (
    e: EmployeeRef,
  ): RouteLocationAsRelative<'/(app)/[org]/people/employees/[id]/'> => ({
    name: '/(app)/[org]/people/employees/[id]/',
    params: { org: e.orgSlug, id: e.id },
  }),
}
